import Swiper from "swiper";
import { Autoplay } from "swiper/modules";
import "swiper/css";
import "swiper/css/autoplay";

export class EndlessSlider {
  constructor() {
    this.sliders = document.querySelectorAll(".js-endless-slider");
    if (!this.sliders) return;

    this.observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            entry.target.swiper.autoplay.start();
          } else {
            entry.target.swiper.autoplay.stop();
          }
        });
      },
      { root: null, threshold: 0, rootMargin: `0px 0px` }
    );

    this.sliders.forEach((slider) => {
      this.cloneSlide(slider);
    });

    window.addEventListener("load", this.init.bind(this));
  }
  init() {
    this.sliders.forEach((slider) => {
      const option = {
        speed: slider.getAttribute("data-speed") || 30000,
        autoplayDirection: slider.classList.contains("-reverse") || false,
        direction: "horizontal",
      };

      if (slider.classList.contains("-vertical")) {
        option.direction = "vertical";
      }

      const swiper = new Swiper(slider, {
        modules: [Autoplay],
        autoplay: {
          delay: 0,
          reverseDirection: option.autoplayDirection,
        },
        direction: option.direction,
        loop: true,
        speed: option.speed,
        slidesPerView: "auto",
        allowTouchMove: false,
      });

      this.observer.observe(swiper.el);
    });
  }
  cloneSlide(slider) {
    const slides = slider.querySelectorAll(".swiper-slide");
    slides.forEach(function (slide) {
      const cloneSlide = slide.cloneNode(true);
      cloneSlide.classList.add("clone");
      slider.querySelector(".swiper-wrapper").appendChild(cloneSlide);
    });
  }
}
